// extracted by mini-css-extract-plugin
export default {"moreInfo":"styles_moreInfo__yuQwn","image":"styles_image__UWn4a"};